<smw-icon [icon]="icon()" />
<div class="caption-xs">{{ label() }}</div>
